webpackJsonp([170786371021445],{

/***/ 936:
/***/ (function(module, exports) {

	module.exports = {"data":{"page":{"id":"/opt/build/repo/content/pages/success/index.md absPath of file >>> MarkdownRemark","html":"<p>Thank you. I will answer to the message as soon as possible.</p>","frontmatter":{"title":"Success"}},"footnote":{"id":"/opt/build/repo/content/parts/footnote.md absPath of file >>> MarkdownRemark","html":"<ul>\n<li>Built by <a href=\"https://www.linkedin.com/in/suyogkc/\">Suyog K.C</a></li>\n<li>with <a href=\"https://www.gatsbyjs.org/\">Gatsby</a> &#x26; <a href=\"https://reactjs.org\">React</a></li>\n<li>source code on <a href=\"https://github.com/suyogkrazz/krazzyblog\">GitHub</a></li>\n</ul>"},"site":{"siteMetadata":{"facebook":{"appId":"434176823700987"}}}},"pathContext":{"slug":"/success/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---success-d400922e0cd5e110360d.js